import * as React from 'react';
import { ArticleHeading2 } from '@cian/ui-kit';

export interface ILetterImgProps {
  letter: string;
  className?: string;
  width?: number;
  height?: number;
}

export function LetterImg({ letter, className, width, height }: ILetterImgProps) {
  return (
    <div className={className} style={{ width, height }}>
      <ArticleHeading2 color="text-primary-disabled">{letter}</ArticleHeading2>
    </div>
  );
}
